import "core-js/modules/es6.object.freeze";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";

var n,
    r = ((n = function n() {
  return r;
}).toString = n.toLocaleString = n[Symbol.toPrimitive] = function () {
  return "";
}, n.valueOf = function () {
  return !1;
}, new Proxy(Object.freeze(n), {
  get: function get(n, t) {
    return n.hasOwnProperty(t) ? n[t] : r;
  }
})),
    t = function t(n) {
  return !(!n || !n.valueOf());
},
    u = function u(n) {
  return n === r;
},
    e = function e(n) {
  return !(n === r || null == n);
},
    o = function o(n) {
  return JSON.stringify(n, function (n, t) {
    return t === r ? null : t;
  });
},
    i = function i(n) {
  return JSON.parse(n, function (n, t) {
    return null === t ? r : t;
  });
};

export { r as Nothing, t as toBool, u as isNothing, e as isSomething, o as serialize, i as deserialize };